import { ArticleParagraph1, Button, useDeviceType, Image } from '@cian/ui-kit';
import styles from './styles.css';
import React from 'react';
import { ETestIds } from 'shared/constants/testIds';
import { ContainerInner } from 'shared/components/ContainerInner';
import cn from 'clsx';

interface IPresentationBlockProps {
  title: string;
  description: string;
  handleClickButton: () => void;
}

export const PresentationBlock: React.FC<IPresentationBlockProps> = ({ title, description, handleClickButton }) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['wrapper'], styles[deviceType])}>
      <ContainerInner>
        <div className={cn(styles['container'], styles[deviceType])}>
          <div className={cn(styles['widget'], styles[deviceType])}>
            <h1 className={cn(styles['title'], styles[deviceType])}>{title}</h1>
            <ArticleParagraph1>{description}</ArticleParagraph1>
            <div className={cn(styles['btn-wrapper'], styles[deviceType])}>
              <Button size={'L'} fullWidth onClick={handleClickButton} data-testid={ETestIds.PresentationBtn}>
                Подобрать предложение
              </Button>
            </div>
          </div>
          <div className={cn(styles['img'], styles[deviceType])}>
            <Image
              src={'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/cat.png'}
              alt="background"
              preloader
              data-testid={ETestIds.PresentationImg}
            />
          </div>
        </div>
      </ContainerInner>
    </div>
  );
};
